import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

const Text = styled.p`
  font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-xs']['font-weight'].value};
  white-space: pre-wrap;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  `}
`

const Outer = styled.div`
  line-height: 1.5;
  margin: 40px 0;
  max-width: 600px;
`

const Description = ({ text }: { text: string }) => {
  return (
    <Outer>
      <Text>{text}</Text>
    </Outer>
  )
}

export default Description
